import ViewportObserverService from "Services/ViewportObserverService";
import { IN_VP_EVENT, OUT_VP_EVENT } from "Constants/eventNames";

class ZhiHomepageHero extends HTMLElement {

  constructor() {
    super();
    this.scrollHandler = () => this.handleScroll();
  }

  connectedCallback() {
    ViewportObserverService.observe(this);

    this.addEventListener(IN_VP_EVENT, () => this.handleInVP());
    this.addEventListener(OUT_VP_EVENT, () => this.handleOutVP());
  }
  
  handleScroll() {
    const scrolledPx = window.scrollY;
    
    const paralaxOffset = scrolledPx * 0.4;

    this.backgroundImage.style.transform = `translateY(${paralaxOffset}px)`;
  }
  
  handleInVP() {
    this.backgroundImage = this.querySelector(".zhi-homepage-hero__background");
    this.scrollBtn = this.querySelector(".zhi-homepage-hero__scroll-down-btn");
    this.scrollBtn.addEventListener("click", () => this.scrollDown());
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
  }
  
  handleOutVP() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  scrollDown() {
    window.scrollTo({
      top: window.innerHeight - 65,
      behavior: "smooth"
    });
  }
}

customElements.define("zhi-homepage-hero", ZhiHomepageHero);